import { create } from "zustand";
import { UtilsStoreProps } from "./interface/utils.interface";
import { getFocusCompany, upsertFocusCompany } from "src/services/company.service";
import { UpsertFocusCompany } from "src/entity/company/focus-company.entity";
import { getAreaByCompany, getMaster } from "src/services/master.service";
import { Master } from "src/entity/report-voc-emission/report-voc-emission.entity";
import { convertEmissionWord } from "src/entity/common/global.entity";

export const utilsStore = create<UtilsStoreProps>((set) => ({
  activeMasterdata: "1", // Last Breadcrumb for Setting Masterdata Menu.
  loading: true,
  data: [],
  dataAreaInCompany: [],
  currentActiveMenus: [],
  masterDataEmission: [],
  getAreaInCompany: async (companyId: string) => {
    try {
      const response = await getAreaByCompany(companyId);
      set(() => ({ dataAreaInCompany: response.data?.data || [] }));
    } catch (error) {}
  },
  getFocusCompany: async (companyId: string) => {
    set(() => ({ loading: true }));
    try {
      const response = await getFocusCompany(companyId);
      set(() => ({ loading: false, data: response.data?.data || [] }));
    } catch (error) {
      set(() => ({ loading: false }));
    }
  },
  upsertFocusCompany: async (data: UpsertFocusCompany) => {
    try {
      await upsertFocusCompany(data);
    } catch (error) {
      console.log();
    }
  },
  setActiveMasterdataTab: async (val: string) => {
    set(() => ({ activeMasterdata: val }));
  },
  setCurrentActiveMenus: (list: string[]) => {
    set(() => ({ currentActiveMenus: list }));
  },
  getMasterDataEmission: async () => {
    set(() => ({ loading: true }));
    try {
      const response = await getMaster();
      const master: Master[] = response.data.data;

      const emissions = master.find((item) => item.label === "Emission");
      if (emissions?.options)
        emissions.options.forEach((item) => {
          item.label = convertEmissionWord(item.label);
        });
      set(() => ({ loading: false, masterDataEmission: emissions?.options || [] }));
    } catch (error) {
      set(() => ({ loading: false }));
    }
  },

  getTextWidth: (text: string, font: string) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      context.font = font;

      const metrics = context.measureText(text);
      return metrics.width;
    }
    return 0;
  },
}));
